export default __webpack_public_path__ + "static/media/logoOriginal.1f4ad850.png";